import SuperFetch, { AbortSuperFetch } from '../helpers/superFetch';
import UrlBuilder from '../helpers/urlBuilder';
import { getAttributes } from '../helpers/urlBuilder';

const { build } = UrlBuilder;
type ApiReqWithParam = (params: getAttributes) => Promise<Response>;
type ApiReqWNoParam = () => Promise<Response>;
/**
 * Klasa zawiera metody służące wysyłaniu zapytań o dane dotyczące studentów do API
 *
 */
class Students {
  /** Pobieranie danych dla tabeli w zakładce "Studenci" */
  getStudents = ({ page, ...rest }: getAttributes, signal: AbortSignal): Promise<Response> => {
    const params: getAttributes = {
      page: page.toString(),
      ...rest,
    };
    const address: string = build('student/ztn_studenci', params);
    return AbortSuperFetch.get(address, signal);
  };
  /** Pobieranie danych dla tabeli w zakładce "Studenci" */
  GetSubjectColumns: ApiReqWNoParam = () => SuperFetch.get('przedmiot/ztn_przedmiot_student_config');
  /** Pobieranie listy studentów dla zakładki pojedynczego przedmiotu */
  getStudentsForSubject = ({ przedmiotId, semester, page, ...rest }: getAttributes, signal: AbortSignal, withCache = false): Promise<Response> => {
    const params: getAttributes = {
      limit: '1000',
      page: page ? page.toString() : null,
      noCache: withCache ? true.toString() : false.toString(),
      ...rest,
    };
    const address: string = build(`student/ztn_pojedyczny_przydzial_studenci/${przedmiotId}/${semester}`, params);
    return AbortSuperFetch.get(address, signal);
  };
  /** Pobieranie listy studentów z ich ocenami w celu wydruku */
  getStudentsWithMarksToPrint = ({ przedmiotId, semester, page, ...rest }: getAttributes, signal: AbortSignal): Promise<Response> => {
    const params: getAttributes = {
      limit: '1000',
      page: page ? page.toString() : null,
      ...rest,
    };
    const address: string = build(`student/ztn_pojedyczny_przydzial_studenci_oceny/${przedmiotId}/${semester}`, params);
    return AbortSuperFetch.get(address, signal);
  };
  /* Pobieranie pliku excel z listą studentów dla przedmiotu */
  getStudentsListExcelFile: ApiReqWithParam = ({ przedmiotId, semester, ...params }) => {
    const address: string = build(`student/ztn_pojedyczny_przydzial_studenci_csv/${przedmiotId}/${semester}`, params);
    return SuperFetch.get(address, undefined, 'csv');
  };
  /** Pobieranie szczegółów o studencie */
  getStudentDetails: ApiReqWithParam = ({ id, ...params }) => {
    const address: string = build(`student/ztn_pojedyczny_student/${id}`, params);
    return SuperFetch.get(address);
  };
  /** Pobieranie listy dostępnych filtrów dla tabeli "Studenci" */
  getStudentsFilterList: ApiReqWNoParam =
    () => SuperFetch.get('student/ztn_studenci_field_filter');
  /** Aktualizacja wartości filtrów tabeli "Studenci" */
  refreshFilterValues = (params: FilterValuePayload, signal: AbortSignal): Promise<Response> => {
    const address: string = build('student/ztn_studenci_multi_filter_value', params);
    return AbortSuperFetch.get(address, signal);
  };
  /** Pobieranie konfiguracji kolumn dla tabeli "Studenci" */
  getColumnsConfig: ApiReqWNoParam = () => SuperFetch.get(`student/ztn_studenci_config`);
  /** Aktualizacja konfiguracji kolumn dla tabeli "Studenci" */
  saveColumnsUserSetup: ApiReqWithParam = ({ columnsSetup }) => {
    const payload = {
      data: JSON.stringify(columnsSetup),
    };
    return SuperFetch.put('uc/user-config/cs_studenci', payload);
  }
  /** Aktualizacja konfiguracji kolumn dla tabeli "przedmioty" w stronie studenta */
  setStudentPageSetup: ApiReqWithParam = ({ columnsSetup }) => {
    const payload = {
      data: JSON.stringify(columnsSetup),
    };
    return SuperFetch.put('uc/user-config/cs_student_prz', payload);
  }
  /** Pobieranie listy przedmiotów dla pojedynczego studenta */
  getSubjectsForStudent: ApiReqWithParam = ({ studentId, semester, page, ...rest }) => {
    const params: getAttributes = {
      limit: '300',
      page: page.toString(),
      ...rest,
    };
    const address: string = build(`student/ztn_pojedyczny_student_przydzialy/${studentId}/${semester}`, params);
    return SuperFetch.get(address);
  };
}

export default new Students();
